export default {
  title: 'Langue',
  save_changes: 'Enregistrer les modifications',
};
